<div class="sopo-popup-inner-container">
  <div class="sopo-popup-title">Waiting Players</div>
  <img class="line" src="/assets/img/lobby/ellipse.svg">
  <div class="waiting-list-container" *ngIf=" waitingPlayers.length !== 0; else noWaitingUser">
      <div class="list-item" *ngFor="let userId of waitingPlayers ;let i = index">
          <span *ngIf="chatUserInfoDispather.getChatUserInfoObservable(userId) | async as userInfo; else loading"> 
              {{ userInfo.displayName }} 
          </span> 
          <span> {{ this.displayPosition(i) }} </span>
      </div>
  </div>
  <div class="sopo-popup-button-container">
      <div class="sopo-popup-green-button clickable" (click)="dismiss()">OK</div>
  </div>
</div>

<ng-template #loading>
  <span>...</span>
</ng-template>

<ng-template #noWaitingUser>
  <div class="sopo-popup-text">The list is empty!</div>
</ng-template>